import axios from 'axios'
import common from '../../static/js/common.js'

axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
axios.defaults.headers.post['model'] = 'json'
axios.defaults.withCredentials = true
// axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
// 添加请求拦截器
axios.interceptors.request.use(
  // 在发送请求之前做些什么
  config => {
    config.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8'
    config.headers['Cache-Control'] = 'no-cache'
    return config
  },
  // 对请求错误做些什么
  error => {
    return Promise.reject(error)
  }
)
// 添加响应拦截器
axios.interceptors.response.use(
  // 对响应数据做点什么
  config => {
    if (config.data.data && config.data.data.hasOwnProperty('loginUserIds') && config.data.login) {
      // 用户信息
      const loginUserKey = {
        loginStatus: true,
        id: config.data.data.loginUserIds.id,
        userName: config.data.data.loginUserIds.username
      }
      window.localStorage.setItem('loginUser', JSON.stringify(loginUserKey))
    }
    if (!config.data.login) {
      window.localStorage.removeItem('loginUser')
    }
    return config
  },
  // 对响应错误做点什么
  error => {
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/api/http.js